import React, { useState } from 'react';
import { TextField, Button, Select, MenuItem, FormControl, InputLabel, Checkbox, Typography, Paper, Grid } from '@mui/material';
import './Task.css';

const Task = ({ task, onComplete, onDelete, onEdit }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newText, setNewText] = useState(task.text);
    const [newPriority, setNewPriority] = useState(task.priority);
    const [newDate, setNewDate] = useState(task.date);

    const handleSave = () => {
        onEdit(task.id, newText, newPriority, newDate);
        setIsEditing(false);
    };

    const isOverdue = new Date(task.date).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
    let priorityClass = '';

    if (isOverdue) {
        priorityClass = 'TaskOverdue';
    } else {
        switch (task.priority) {
            case 'high':
                priorityClass = 'TaskHighPriority';
                break;
            case 'medium':
                priorityClass = 'TaskMediumPriority';
                break;
            case 'low':
                priorityClass = 'TaskLowPriority';
                break;
            default:
                break;
        }
    }

    return (
        <Paper className={`Task ${task.completed ? 'TaskCompleted' : ''} ${priorityClass}`} elevation={3} style={{ padding: 20 }}>
            {isEditing ? (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                value={newText}
                                onChange={(e) => setNewText(e.target.value)}
                                label="Task name"
                                variant="outlined"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth>
                            <InputLabel>Priority</InputLabel>
                            <Select
                                value={newPriority}
                                onChange={(e) => setNewPriority(e.target.value)}
                                label="Priority"
                            >
                                <MenuItem value="low">Low</MenuItem>
                                <MenuItem value="medium">Medium</MenuItem>
                                <MenuItem value="high">High</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            type="date"
                            value={newDate}
                            onChange={(e) => setNewDate(e.target.value)}
                            label="Deadline"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <Button variant="contained" color="primary" onClick={handleSave} fullWidth>
                            Save
                        </Button>
                        <Button variant="contained" color="secondary" onClick={() => setIsEditing(false)} fullWidth style={{ marginTop: 10 }}>
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={2} alignItems="center">
                    <Grid item>
                        <Checkbox
                            checked={task.completed}
                            onChange={() => onComplete(task.id)}
                        />
                    </Grid>
                    <Grid item xs>
                        <Typography variant="h6">{task.text}</Typography>
                        <Typography variant="body2">Priority: {task.priority}</Typography>
                        <Typography variant="body2">Deadline: {task.date}</Typography>
                        <Typography variant="body2">Created at: {new Date(task.createdAt).toLocaleString()}</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant="contained" onClick={() => setIsEditing(true)}>Edit</Button>
                        <Button variant="contained" color="secondary" onClick={() => onDelete(task.id)} style={{ marginLeft: 10 }}>
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            )}
        </Paper>
    );
};

export default Task;
